import { Component } from 'react';
import { logger } from '@utils/logger';
import Button from './Button';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logger.error('ErrorBoundary caught an error', { error, errorInfo });
    this.setState({
      error,
      errorInfo,
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
          <div className="max-w-md w-full text-center">
            <div className="mb-8">
              <h1 className="text-6xl font-bold text-secondary-600 mb-4">
                Oops!
              </h1>
              <h2 className="text-2xl font-semibold text-primary-700 mb-2">
                Something went wrong
              </h2>
              <p className="text-primary-600">
                We're sorry for the inconvenience. An unexpected error has occurred.
              </p>
            </div>

            {this.state.error && (
              <div className="mb-6 p-4 bg-secondary-50 rounded-lg text-left">
                <p className="text-sm font-mono text-secondary-800 break-all">
                  {this.state.error.toString()}
                </p>
              </div>
            )}

            <div className="space-y-3">
              <Button onClick={this.handleReset} variant="primary" fullWidth>
                Go to Home
              </Button>
              <Button onClick={() => window.location.reload()} variant="outline" fullWidth>
                Reload Page
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
